import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {PageListConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import { PageListComponent } from '../../../fw/pages/page-list.component';
import { FoundByComponent } from './found-by.component';
import { BtwComponent } from './btw.component';
import { MutationGroupComponent } from './mutationgroup.component';
import { TreatmentSalesgroupComponent } from './treatment-salesgroup.component';
import { SettingsBaseService } from './settings-base.service';
import { DialogService } from '@progress/kendo-angular-dialog';
import { SharedService } from '../../shared/shared.service';
import { DtoDeleteResult } from '../../shared/models/DtoDeleteResult';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ArticleSalesgroupComponent} from "./article-salesgroup.component";
import {CashregGroupComponent} from "./cashreggroup.component";
import {DepartmentComponent} from "./department.component";
import {SupplierComponent} from "./supplier.component";
import {DtoArticleSalesgroup} from "./models/DtoArticleSalesgroup";
import {DtoTreatmentSalesgroup} from "./models/DtoTreatmentSalesgroup";
import {DtoSupplier} from "./models/DtoSupplier";
import {DtoDepartment} from "./models/DtoDepartment";
import {DtoCashregGroup} from "./models/DtoCashregGroup";
import {DtoMutationGroup} from "./models/DtoMutationGroup";
import {DtoBtwGroup} from "./models/DtoBtwGroup";
import {DtoCustomerOrigin} from "./models/DtoCustomerOrigin";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {FormService} from "../../../fw/services/form.service";
import {DtoFinancialSettingsUser} from "./models/DtoFinancialSettingsUser";
import {DtoOtherSettingsUserSetting} from "./models/DtoOtherSettingsUserSetting";
import {FilePickerDirective, ReadFile, ReadMode} from "ngx-file-helpers";
import {ChangeUserPasswordComponent} from "./change-user-password.component";

@Component({
    selector: 'app-settings-base',
    template: require('./settings-base.component.html'),
    styles: [require('./settings-base.component.css')]
})
@AutoUnsubscribe()
export class SettingsBaseComponent implements OnInit {
    @ViewChild('pageTreatmentSalesgroups', {static: false}) pageTreatmentSalesgroups: PageListComponent;
    @ViewChild('pageArticleSalesgroups', {static: false}) pageArticleSalesgroups: PageListComponent;
    @ViewChild('pageSuppliers', {static: false}) pageSuppliers: PageListComponent;
    @ViewChild('pageDepartments', {static: false}) pageDepartments: PageListComponent;
    @ViewChild('pageCashregGroups', {static: false}) pageCashregGroups: PageListComponent;
    @ViewChild('pageMutationGroups', {static: false}) pageMutationGroups: PageListComponent;
    @ViewChild('pageBtwGroups', {static: false}) pageBtwGroups: PageListComponent;
    @ViewChild('pageFoundBy', {static: false}) pageFoundBy: PageListComponent;
    @ViewChild(FilePickerDirective, {static: false})
    filePicker;
    readMode = ReadMode.dataURL;
    picked: ReadFile;
    
    configTreatmentSalesgroups: PageListConfig;
    configArticleSalesgroups: PageListConfig;
    configSuppliers: PageListConfig;
    configDepartments: PageListConfig;
    configCashregGroups: PageListConfig;
    configMutationGroups: PageListConfig;
    configBtwGroups: PageListConfig;
    configFoundBy: PageListConfig;

    treatmentSalesgroupData: DtoTreatmentSalesgroup[];
    articleSalesgroupData: DtoArticleSalesgroup[];
    supplierData: DtoSupplier[];
    departmentData: DtoDepartment[];
    cashregGroupData: DtoCashregGroup[];
    mutationGroupData: DtoMutationGroup[];
    btwGroupData: DtoBtwGroup[];
    foundByData: DtoCustomerOrigin[];
    pshbFinancialConfig: PageSubheaderBarConfig;
    formFinancial: FormGroup;
    dtoFinancial: DtoFinancialSettingsUser;

    pshbOtherConfig: PageSubheaderBarConfig;
    formOther: FormGroup;
    dtoOther: DtoOtherSettingsUserSetting;

    loyaltyPointsUseItems: Array<{ text: string, value: number }> = [
        { text: "Nee", value: 0 },
        { text: "Op beide", value: 1 },
        { text: "Op artikel", value: 2 },
        { text: "Op behandeling", value: 3 }
    ];
    wagesTypeItems: Array<{ text: string, value: number }> = [
        { text: "Loongebouw A", value: 0 },
        { text: "Loongebouw B", value: 1 }
    ];
    checkCustomerDataItems: Array<{ text: string, value: number }> = [
        { text: "Nee", value: 0 },
        { text: "Ja, e-mail", value: 1 },
        { text: "Ja, mobiel nummer", value: 2 },
        { text: "Ja, beide", value: 3 }
    ];
    yesNoItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private dialogService: DialogService,
                private ss: SharedService,
                private ds: SettingsBaseService,
                private fs: FormService,
                private fb: FormBuilder,
                private router: Router) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'instellingen', isLastStep: false },
            { text: 'basisinstellingen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.configTreatmentSalesgroups = {
            pageHeaderBarConfig: {
                title: 'BEHANDEL OMZETGROEPEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.configArticleSalesgroups = {
            pageHeaderBarConfig: {
                title: 'ARTIKEL OMZETGROEPEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.configSuppliers = {
            pageHeaderBarConfig: {
                title: 'LEVERANCIERS',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'name',
                    label: 'Leveranciersnaam',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'city',
                    label: 'Leveranciersnaam',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'phoneNo',
                    label: 'Telefoonnummer',
                    type: 'string',
                    width: '*'
                }
            ],
            rowKey: 'id'
        };

        this.configDepartments = {
            pageHeaderBarConfig: {
                title: 'AFDELINGEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'laTreatment',
                    label: 'Grootboeknr ambacht',
                    type: 'string',
                    width: '200px'
                },
                {
                    key: 'laArticle',
                    label: 'Grootboeknr verkoop',
                    type: 'string',
                    width: '200px'
                },
                {
                    key: 'laTreatmentDiscount',
                    label: 'Grootboeknr korting ambacht',
                    type: 'string',
                    width: '250px'
                },
                {
                    key: 'laArticleDiscount',
                    label: 'Grootboeknr korting verkoop',
                    type: 'string',
                    width: '250px'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.configCashregGroups = {
            pageHeaderBarConfig: {
                title: 'KASSAGROEPEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.configMutationGroups = {
            pageHeaderBarConfig: {
                title: 'MUTATIEGROEPEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'grootboekNumber',
                    label: 'Grootboeknummer',
                    type: 'string',
                    width: '150px'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.configBtwGroups = {
            pageHeaderBarConfig: {
                title: 'BTW GROEPEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'percentage',
                    label: '% BTW',
                    type: 'string',
                    width: '100px',
                    format: '{0:0.0}%'
                },
                {
                    key: 'accountacyCode',
                    label: 'Code boekhouding',
                    type: 'string',
                    width: '150px'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.configFoundBy = {
            pageHeaderBarConfig: {
                title: 'GEVONDEN VIA',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'index',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '120px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '80px'
                }
            ],
            rowKey: 'id'
        };

        this.pshbFinancialConfig = {
            title: '',
            buttonDefinition: [
                {
                    clickEventType: 'save',
                    description: 'OPSLAAN',
                    isSmall: false
                },
                {
                    clickEventType: 'cancel',
                    description: 'ANNULEREN',
                    isSmall: false
                }
            ]
        };

        this.formFinancial = this.fb.group({
            loyaltyPointsUse: null,
            loyaltyPointsForSpentAmount: null,
            loyaltyPointsValuePoint: null,
            loyaltyPointsShowByCustomer: null,
            loyaltyPointsWarningAtAmount: null,
            loyaltyPointsUseRelationNo: null,
            userSetting: this.fb.group({
                id: null,
                laDebitPayed: null,
                laDebitCreated: null,
                laCreditCreated: null,
                laPayedWithCredit: null,
                laGiftCertificateCreated: null,
                laPayedWithGiftCertificate: null,
                laCashDifference: null,
                laCashDeposit: null,
                laChiral: null,
                treatmentGrowthPercentage: null,
                articleGrowthPercentage: null,
                wagesType: null,
                sueDirectorName: null,
                sueDirectorEmail: null,
                sueSpendAmount: null,
                sueCouponAmount: null,
                sueFeedbackVisitCount: null
            })
        });

        this.pshbOtherConfig = {
            title: '',
            buttonDefinition: [
                {
                    clickEventType: 'changepassword',
                    description: 'WACHTWOORD',
                    isSmall: false
                },
                {
                    clickEventType: 'save',
                    description: 'OPSLAAN',
                    isSmall: false
                },
                {
                    clickEventType: 'cancel',
                    description: 'ANNULEREN',
                    isSmall: false
                }
            ]
        };

        this.formOther = this.fb.group({
            showTimesheetOnLogin: null,
            checkCustomerData: null,
            checkCustomerDataCode: null,
            checkCustomerDataWeeks: null,
            validateFoundBy: null,
            useDepositNo: null,
            subscriptionActiveForAllBranches: null,
            showTicketOnPosDisplay: null
        });
    }

    ngAfterViewInit() {
        this.loadTreatmentSalesgroups(false);
    }

    tabSelected(e) {
        if (e.index == 0) {
            this.loadTreatmentSalesgroups(false);
        } else if (e.index == 1) {
            this.loadArticleSalesgroups(false);
        } else if (e.index == 2) {
            this.loadSuppliers(false);
        } else if (e.index == 3) {
            this.loadDepartments(false);
        } else if (e.index == 4) {
            this.loadCashregGroups(false);
        } else if (e.index == 5) {
            this.loadMutationGroups(false);
        } else if (e.index == 6) {
            this.loadBtwGroups(false);
        } else if (e.index == 7) {
            this.loadFoundBys(false);
        } else if (e.index == 8) {
            this.loadFinancial(false);
        } else if (e.index == 9) {
            this.loadOther(false);
        }
    }

    // TREATMENTSALESGROUP
    loadTreatmentSalesgroups(reload: boolean) {
        if (reload || !this.treatmentSalesgroupData) {
            this.ds.getTreatmentSalesgroups().subscribe((res: DtoTreatmentSalesgroup[]) => {
                this.treatmentSalesgroupData = res;
                this.pageTreatmentSalesgroups.setGridData(this.treatmentSalesgroupData);
            });
        }
    }

    pageTreatmentSalesgroupsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showTreatmentSalesgroupsEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageTreatmentSalesgroups.grid.getSelectedId() > 0) {
                this.showTreatmentSalesgroupsEditWindow(this.pageTreatmentSalesgroups.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageTreatmentSalesgroups.grid.getSelectedId() > 0) {
                this.showTreatmentSalesgroupsEditWindow(0, this.pageTreatmentSalesgroups.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageTreatmentSalesgroups.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteTreatmentSalesgroupById(this.pageTreatmentSalesgroups.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadTreatmentSalesgroups(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageTreatmentSalesgroupsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showTreatmentSalesgroupsEditWindow(event, 0);
        }
    }

    showTreatmentSalesgroupsEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: TreatmentSalesgroupComponent
        });

        const dialogContent: TreatmentSalesgroupComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadTreatmentSalesgroups(true);
                }
            });
    }

    // ARTICLESALESGROUP
    loadArticleSalesgroups(reload: boolean) {
        if (reload || !this.articleSalesgroupData) {
            this.ds.getArticleSalesgroups().subscribe((res: DtoArticleSalesgroup[]) => {
                this.articleSalesgroupData = res;
                this.pageArticleSalesgroups.setGridData(this.articleSalesgroupData);
            });
        }
    }

    pageArticleSalesgroupsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showArticleSalesgroupsEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageArticleSalesgroups.grid.getSelectedId() > 0) {
                this.showArticleSalesgroupsEditWindow(this.pageArticleSalesgroups.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageArticleSalesgroups.grid.getSelectedId() > 0) {
                this.showArticleSalesgroupsEditWindow(0, this.pageArticleSalesgroups.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageArticleSalesgroups.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteArticleSalesgroupById(this.pageArticleSalesgroups.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadArticleSalesgroups(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageArticleSalesgroupsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showArticleSalesgroupsEditWindow(event, 0);
        }
    }

    showArticleSalesgroupsEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: ArticleSalesgroupComponent
        });

        const dialogContent: ArticleSalesgroupComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadArticleSalesgroups(true);
                }
            });
    }

    // SUPPLIER
    loadSuppliers(reload: boolean) {
        if (reload || !this.supplierData) {
            this.ds.getSuppliers().subscribe((res: DtoSupplier[]) => {
                this.supplierData = res;
                this.pageSuppliers.setGridData(this.supplierData);
            });
        }
    }

    pageSuppliersBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showSuppliersEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageSuppliers.grid.getSelectedId() > 0) {
                this.showSuppliersEditWindow(this.pageSuppliers.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageFoundBy.grid.getSelectedId() > 0) {
                this.showSuppliersEditWindow(0, this.pageSuppliers.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageSuppliers.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteSupplierById(this.pageSuppliers.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadSuppliers(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageSuppliersGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showSuppliersEditWindow(event, 0);
        }
    }

    showSuppliersEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: SupplierComponent
        });

        const dialogContent: SupplierComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadSuppliers(true);
                }
            });
    }

    // DEPARTMENT
    loadDepartments(reload: boolean) {
        if (reload || !this.departmentData) {
            this.ds.getDepartments().subscribe((res: DtoDepartment[]) => {
                this.departmentData = res;
                this.pageDepartments.setGridData(this.departmentData);
            });
        }
    }

    pageDepartmentsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showDepartmentsEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageDepartments.grid.getSelectedId() > 0) {
                this.showDepartmentsEditWindow(this.pageDepartments.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageDepartments.grid.getSelectedId() > 0) {
                this.showDepartmentsEditWindow(0, this.pageDepartments.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageDepartments.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteDepartmentById(this.pageDepartments.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadDepartments(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageDepartmentsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showDepartmentsEditWindow(event, 0);
        }
    }

    showDepartmentsEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: DepartmentComponent
        });

        const dialogContent: DepartmentComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadDepartments(true);
                }
            });
    }

    // CASHREGGROUP
    loadCashregGroups(reload: boolean) {
        if (reload || !this.cashregGroupData) {
            this.ds.getCashregGroups().subscribe((res: DtoCashregGroup[]) => {
                this.cashregGroupData = res;
                this.pageCashregGroups.setGridData(this.cashregGroupData);
            });
        }
    }

    pageCashregGroupsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showCashregGroupsEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageCashregGroups.grid.getSelectedId() > 0) {
                this.showCashregGroupsEditWindow(this.pageCashregGroups.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageCashregGroups.grid.getSelectedId() > 0) {
                this.showCashregGroupsEditWindow(0, this.pageCashregGroups.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageCashregGroups.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteCashregGroupById(this.pageCashregGroups.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadCashregGroups(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageCashregGroupsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showCashregGroupsEditWindow(event, 0);
        }
    }

    showCashregGroupsEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: CashregGroupComponent
        });

        const dialogContent: CashregGroupComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadCashregGroups(true);
                }
            });
    }

    // MUTATIONGROUP
    loadMutationGroups(reload: boolean) {
        if (reload || !this.mutationGroupData) {
            this.ds.getMutationGroups().subscribe((res: DtoMutationGroup[]) => {
                this.mutationGroupData = res;
                this.pageMutationGroups.setGridData(this.mutationGroupData);
            });
        }
    }

    pageMutationGroupsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showMutationGroupsEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageMutationGroups.grid.getSelectedId() > 0) {
                this.showMutationGroupsEditWindow(this.pageMutationGroups.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageMutationGroups.grid.getSelectedId() > 0) {
                this.showMutationGroupsEditWindow(0, this.pageMutationGroups.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageMutationGroups.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteMutationGroupById(this.pageMutationGroups.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadMutationGroups(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageMutationGroupsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showMutationGroupsEditWindow(event, 0);
        }
    }

    showMutationGroupsEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: MutationGroupComponent
        });

        const dialogContent: MutationGroupComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadMutationGroups(true);
                }
            });
    }

    // BTW
    loadBtwGroups(reload: boolean) {
        if (reload || !this.btwGroupData) {
            this.ds.getBtwGroups().subscribe((res: DtoBtwGroup[]) => {
                this.btwGroupData = res;
                this.pageBtwGroups.setGridData(this.btwGroupData);
            });
        }
    }

    pageBtwGroupsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showBtwGroupEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageBtwGroups.grid.getSelectedId() > 0) {
                this.showBtwGroupEditWindow(this.pageBtwGroups.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageBtwGroups.grid.getSelectedId() > 0) {
                this.showBtwGroupEditWindow(0, this.pageBtwGroups.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageBtwGroups.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteBtwGroupById(this.pageBtwGroups.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadBtwGroups(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageBtwGroupsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showBtwGroupEditWindow(event, 0);
        }
    }

    showBtwGroupEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: BtwComponent
        });

        const dialogContent: BtwComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadBtwGroups(true);
                }
            });
    }

    // FOUND BY
    loadFoundBys(reload: boolean) {
        if (reload || !this.foundByData) {
            this.ds.getCustomerOrigins().subscribe((res: DtoCustomerOrigin[]) => {
                this.foundByData = res;
                this.pageFoundBy.setGridData(this.foundByData);
            });
        }
    }

    pageFoundByBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showFoundByEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageFoundBy.grid.getSelectedId() > 0) {
                this.showFoundByEditWindow(this.pageFoundBy.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageFoundBy.grid.getSelectedId() > 0) {
                this.showFoundByEditWindow(0, this.pageFoundBy.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageFoundBy.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteCustomerOriginById(this.pageFoundBy.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadFoundBys(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageFoundByGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showFoundByEditWindow(event, 0);
        }
    }

    showFoundByEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: FoundByComponent
        });

        const dialogContent: FoundByComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadFoundBys(true);
                }
        });
    }

    // FINANCIAL
    loadFinancial(reload: boolean) {
        if (reload || !this.dtoFinancial) {
            this.ds.getFinancialSettings()
                .subscribe(response => {
                    this.dtoFinancial = response;
                    this.fs.patchDtoToForm(this.dtoFinancial, this.formFinancial);
                });
        }
    }

    phbFinancialBtnClicked(event) {
        if (event == 'cancel') {
            this.router.navigate(['/auth/home']);
        } else if (event == 'save') {
            let result = this.fs.patchFormToDto(this.dtoFinancial, this.formFinancial);
            this.ds.saveFinancialSettings(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.router.navigate(['/auth/home']);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    // OTHER
    loadOther(reload: boolean) {
        if (reload || !this.dtoOther) {
            this.ds.getOtherSettings()
                .subscribe(response => {
                    this.dtoOther = response;
                    this.fs.patchDtoToForm(this.dtoOther, this.formOther);
                });
        }
    }

    phbOtherBtnClicked(event) {
        if (event == 'cancel') {
            this.router.navigate(['/auth/home']);
        } else if (event == 'save') {
            let result = this.fs.patchFormToDto(this.dtoOther, this.formOther);
            this.ds.saveOtherSettings(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.router.navigate(['/auth/home']);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        } else if (event === 'changepassword') {
            this.showChangeUserPasswordWindow();
        }
    }

    showChangeUserPasswordWindow() {
        const dialogRef = this.dialogService.open({
            content: ChangeUserPasswordComponent
        });

        const dialogContent: ChangeUserPasswordComponent =
            dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
    }

    onLogoFilePicked(file: ReadFile) {
        this.picked = file;
        this.ss.chooseImage(this.picked.content, 280, 1)
            .subscribe((res: string) => {
                if (res) {
                    this.dtoOther.companyLogo = res;
                }
            });
    }

    onLogoFileReadEnd(fileCount: number) {
        this.filePicker.reset();
    }

    btnDeleteLogoClicked(event) {
        this.ss.confirm('Weet u zeker dat u het bedrijfslogo wilt verwijderen?')
            .subscribe((res: boolean) => {
                if (res) {
                    this.dtoOther.companyLogo = null;
                }
            });
    }

    getCompanyLogo() {
        if (this.dtoOther && this.dtoOther.companyLogo) {
            return `data:image/jpg;base64,${this.dtoOther.companyLogo}`;
        }

        return '/assets/images/chooseImage.png';
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-base/settings-base.component.ts